// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signOut, onAuthStateChanged } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCkSmo_LHzjiA5BxP8EpM8foPjglrd16qQ",
  authDomain: "spacepings-616e4.firebaseapp.com",
  projectId: "spacepings-616e4",
  storageBucket: "spacepings-616e4.firebasestorage.app",
  messagingSenderId: "1051916271259",
  appId: "1:1051916271259:web:64f82fa7d02cbf0f83d03e",
  measurementId: "G-EKD55LLT4F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Google Auth Provider with custom branding
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');
googleProvider.setCustomParameters({
  prompt: 'select_account',
  // Remove domain restriction to allow all Google accounts
  include_granted_scopes: 'true'
});

// Auth functions
export const signInWithGoogle = () => {
  console.log('signInWithPopup called with provider:', googleProvider);
  
  return signInWithPopup(auth, googleProvider).catch(error => {
    console.error('Google sign-in error:', error);
    
    // Handle common error cases
    if (error.code === 'auth/popup-blocked') {
      throw new Error('Pop-up was blocked by your browser. Please allow pop-ups for this site and try again.');
    } else if (error.code === 'auth/popup-closed-by-user') {
      throw new Error('Sign-in was cancelled. Please try again.');
    } else if (error.code === 'auth/unauthorized-domain') {
      throw new Error('This domain is not authorized for Google sign-in. Please contact support.');
    } else if (error.code === 'auth/operation-not-allowed') {
      throw new Error('Google sign-in is not enabled. Please contact support.');
    }
    
    // Re-throw the original error if it's not a known case
    throw error;
  });
};

export const handleRedirectResult = () => {
  return getRedirectResult(auth).then(result => {
    if (result) {
      console.log('Redirect sign-in successful:', result);
      return result;
    }
    return null;
  }).catch(error => {
    console.error('Redirect sign-in failed:', error);
    throw error;
  });
};

export const logOut = () => {
  return signOut(auth);
};

export const onAuthStateChange = (callback: (user: any) => void) => {
  return onAuthStateChanged(auth, callback);
};

export { auth, analytics };
export default app;